// extracted by mini-css-extract-plugin
export var smallSpinner = "_s2-0";